import { FormValidations } from "features/shared/forms/hooks/useForm";
import FilesValidationRule from "features/validation/rules/FilesValidationRule";
import { TFunction } from "i18next";
import { getFileExtensionValidationMessage, getSingleFileValidationMessage } from 'features/shared/helpers/translationHelper'

export const insertDocumentValidations = (t: TFunction): FormValidations => {
  return {
    documentType: {
      required: true,
      type: "OnlyRequired",
    },
    file: {
      required: true,
      requiredMessage: "fileInputInvalid",
      message: `${getSingleFileValidationMessage(t)} ${getFileExtensionValidationMessage(t)}`,
      type: "Files",
      filesCount: 1,
    } as FilesValidationRule,
  };
};